import type { FetchSixesCatalogParams } from '@/types/SixCatalogDTOs';
import type { MappedSixesCatalogResponse } from '@/store/mappers/sixCatalog';
import { mapSixesCatalogPayloadDTOToResponse } from '@/store/mappers/sixCatalog';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { initializeP2PStacksForCatalog } from '@/store/thunks/sixCatalog/initializeP2PStacksForCatalog';

export const refreshSixCatalogThunk = createAppAsyncThunk<
  MappedSixesCatalogResponse,
  FetchSixesCatalogParams | undefined
>('catalog/refreshSixes', async (params, { dispatch, extra, getState }) => {
  const { filters, search, sortField, sortDirection } = getState().sixCatalog;
  const apiResponse = await extra.sixCatalogService.fetchSixes({
    filters,
    search,
    sortField,
    sortDirection,
    ...params,
  });
  const mappedResponse = mapSixesCatalogPayloadDTOToResponse(apiResponse);

  initializeP2PStacksForCatalog(dispatch, mappedResponse.sixes);

  return mappedResponse;
});
